export const getITH = async (prizeCategory: string) => {
  if (prizeCategory === "dreamCar") {
    return await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetInTheHeadlightData`);
  }
  return await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/instantwin/GetInstantWinInTheHeadlightData`);
};

export const getCountdownClockData = async (competitionType: string) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetCountdownClock?competitionType=${competitionType}`
  );

export const getMakesAndStyles = async () =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetMakesAndStyles?competitionPath=${location.pathname}`
  );

export const getCarPrizes = async () => {
  return await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetPrizes?competitionPath=${location.pathname}&isCompetitionPage=true&quantityOfResults=0&sortOrder=0`
  );
};

export const getMythIcons = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetMythIcons`);

export const getCarPrizeDetails = async (prizeUrl: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/dreamcar/GetCarPrizeDetails?prizeUrl=${prizeUrl}`);

export const getInstantWinData = async (competitionTypeId: string, competitionId: number) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/instantwin/GetInstantWinDataOnPrizesTab?competitionTypeId=${competitionTypeId}&competitionId=${competitionId}`
  );

export const getInstantWinPrizes = async (competitionId: number) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/instantwin/GetInstantWinData?competitionId=${competitionId}`
  );

export const getInstantWinDataOnInstantWinTab = async (competitionTypeId: string, competitionId: number) => {
  return await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/instantwin/GetInstantWinDataOnInstantWinTab?competitionTypeId=${competitionTypeId}&competitionId=${competitionId}`
  );
};

export const getInstantWinPrizeDetails = async (
  prizeId: number,
  pageIndex: number,
  pageSize: number,
  competitionId: number
) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/instantwin/getcachedinstantwinprizeinfo?prizeID=${prizeId}&page=${pageIndex}&pageSize=${pageSize}&competitionId=${competitionId}`
  );
